import React from "react";
import { styled } from "styled-components";

interface Props {
  color: string;
  label: string;
  className?: string;
}

/** Soft neutral fill + a border/text in the passed accent color, matching Spotter's own chip
 *  pattern (\`TagChip\`/\`GlossaryChip\`/\`TrayChip\`: a neutral background, colored 1px border,
 *  colored text) instead of a fully opaque solid fill. */
const StyledBadge = styled.div`
  height: 25px;
  padding: 0 10px;
  display: inline-flex;
  align-items: center;
  background-color: var(--dark300);
  flex-grow: 0;
  border-radius: 7px;
`;

const Badge = (props: Props) => {
  const { color, label, className } = props;
  return (
    <div className={className}>
      <StyledBadge style={{ border: `1px solid ${color}`, color }}>
        {label}
      </StyledBadge>
    </div>
  );
};

export default Badge;
